import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';

interface MarkdownRendererProps {
  content: string;
  className?: string;
}

export const MarkdownRenderer: React.FC<MarkdownRendererProps> = ({ 
  content, 
  className = '' 
}) => {
  return (
    <div className={`markdown-content ${className}`}>
      <ReactMarkdown
        remarkPlugins={[remarkMath]}
        rehypePlugins={[rehypeKatex]}
        components={{
          // Custom rendering for math blocks
          div: ({ node, className, children, ...props }) => {
            if (className?.includes('math-display')) {
              return <div className={`math-display ${className}`} {...props}>{children}</div>;
            }
            return <div className={className} {...props}>{children}</div>;
          },
          // Custom rendering for inline math
          span: ({ node, className, children, ...props }) => {
            if (className?.includes('math-inline')) {
              return <span className={`math-inline ${className}`} {...props}>{children}</span>;
            }
            return <span className={className} {...props}>{children}</span>;
          }
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
};
